import React from 'react';
import s from './style.scss';
import classNames from 'classnames';
const AccountTypeCard = ({ style, typeIcon, text, active = false, onClick }) => {
    return (React.createElement("div", { className: classNames(s.card, style, { [s.pointer]: onClick, [s.activeCard]: active }), onClick: onClick },
        React.createElement("div", { className: s.typeIcon }, typeIcon),
        React.createElement("div", { className: s.text }, text)));
};
export default AccountTypeCard;
